/**
 * Migrates localStorage keys from the old `dataGrid2.*` prefix to the current `dataGrid.*` prefix.
 *
 * During a previous migration, datagrid keys were renamed from `dataGrid.*` to `dataGrid2.*`.
 * Now that we've cleaned up the codebase to use `dataGrid.*` again, customers may still have
 * `dataGrid2.*` keys in their browser. This function:
 *
 * 1. Checks if any `dataGrid2.*` keys exist
 * 2. If yes, removes all existing `dataGrid.*` keys (stale leftovers from the original v1 naming)
 * 3. Copies all `dataGrid2.*` values to their `dataGrid.*` equivalents
 * 4. Removes all `dataGrid2.*` keys
 */
export function migrateDataGridLocalStorageKeys() {
  const v2Prefix = 'dataGrid2.';
  const v1Prefix = 'dataGrid.';

  const allKeys = Object.keys(localStorage);

  const v2Keys = allKeys.filter((key) => key.startsWith(v2Prefix));

  if (v2Keys.length === 0) {
    return;
  }

  const v1Keys = allKeys.filter((key) => key.startsWith(v1Prefix));
  v1Keys.forEach((key) => localStorage.removeItem(key));

  v2Keys.forEach((key) => {
    const newKey = v1Prefix + key.slice(v2Prefix.length);
    const value = localStorage.getItem(key);

    if (value !== null) {
      localStorage.setItem(newKey, value);
    }

    localStorage.removeItem(key);
  });
}
